/**
 *
 * @description Highlight.js
 * @author yikkok <yikok.yong@gmail.com>
 * @version 1.0.0
 * @since 18 July 2020
 *
 */

import * as React from "react"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  highlight: {
    color: theme.palette.primary.main,
  },
}))

export default function Highlight(props) {
  const { children } = props
  const classes = useStyles()
  return <strong className={classes.highlight}>{children}</strong>
}
